module.exports = __webpack_public_path__ + "img/pin-sekolah.bc3a2622.png";